import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import '../../Placement.css';
import bannerImage from "../../Images/Banner/university.webp";
import { Container, Row, Col, Card } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classroomImage from "../../Images/placement/placement1.webp";

const GlobalSkills = () => {

    const highlights = [
        {
            title: 'Global Business Practices:',
            text: 'About global business, international trade and economic policies, we equip the students with the necessary understanding to prepare them for the world market. Knowledge of how enterprises operate increases students’ performance depending on the conditions of the markets and culture.',
        },
        {
            title: 'Cross-Cultural Communication:',
            text: 'Cultural communication is an important factor in understanding in the current diversified employee population. We have specialized courses in training that deals with the student’s interpersonal communication skills in other to be able to familiar with the different culturally diverse clients encountered in clinical setting.',
        },
    ];

    const marketingData = [
        {
            title: "Experience Diverse Cultures:",
            content:
                "Studying and living in another country plays an instrumental role when it comes to learning new ways of learning to survive and engage various cultures, which is very key when it comes to taking up a job in the contemporary world.",
        },
        {
            title: "Network Internationally:",
            content:
                "Such programs enable students to interact with fellow students and practitioners from other parts of the globe hence enabling students to establish good networks to refer to in their future working places.",
        },
        {
            title: "Collaborate on Global Projects:",
            content:
                "Almost all universities offer group projects with international students; this means that our students are able to practice what we taught them on a real life case scenario and also they get to learn how to work in groups with people from other parts of the world.",
        },
    ];

    const principles = [
        {
            title: "Guest Lectures and Workshops:",
            icon: "ti ti-medal",
            description:
                "Prominent industry leaders from all over the world are invited to deliver workshops and seminars to share some unfamiliar concepts and key issues of the global industry to the students.",
        },
        {
            title: "Internship Opportunities:",
            icon: "ti ti-user",
            description:
                "Bringing relations with industries all over the world enables us to place students for internships within some of these proprietary worldwide, allowing students an understanding of business within an international context.",
        },
        {
            title: "Research Collaborations:",
            icon: "ti ti-brain",
            description:
                "Such arrangements afford the students possibilities for participating in research with institutions in other countries and, consequently, to become accustomed to different approaches and methods of research",
        },
    ];

    return (
        <>
            <title>Global Readiness | ISBM University – Prepare for Global Success</title>
            <meta
                name="description"
                content="Be career-ready on a global scale — ISBM University offers you exposure, networks & skills to thrive in an interconnected world."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>Global Skills</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Global Skills
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* Training */}
            <section className="container-xxl ptb-50">
                <Row>
                    <Col md={6}>
                        <div className="row align-items-center">
                            <div className="p-4">
                                <h2 className="modern-title text-blue">
                                    Global Skills
                                </h2>
                                <div className="underline-divider mb-3"></div>
                                <p>
                                    In today’s interconnected world, the demand for professionals who possess global skills is more important than ever.
                                    At ISBM University, we are dedicated to equipping our students with the international competencies and cross-cultural
                                    understanding necessary to thrive in a globalized job market. Our global skills development initiatives are designed to
                                    foster a comprehensive understanding of diverse cultures, business practices, and global trends.
                                </p>
                            </div>
                        </div>
                    </Col>
                    <div className="col-md-6 mt-5 d-flex justify-content-center">
                        <div className="image-wrapper position-relative">
                            <div className="image-bg"></div>
                            <img
                                src={classroomImage}
                                className="img-fluid rounded placement-image position-relative"
                                alt="Placement Classroom"
                            />
                        </div>
                    </div>
                </Row>
            </section>

            <section className="ptb-50 justify-content-between highlights">
                <div className="container-xxl">
                    <h2 className="modern-title text-blue section-title text-center">
                        Emphasis on International Competencies
                    </h2>
                    <p className="lead">
                        Our curriculum is structured to include various elements that promote international competencies,
                        such as:Our curriculum is structured to include various elements that promote international competencies,
                        such as:
                    </p>
                    <Row className="mt-3">
                        {highlights.map((item, index) => (
                            <Col md={6} lg={6} className="mb-3" key={index}>
                                <div className="highlight-card1 d-flex shadow rounded-4">
                                    <div className="highlight-content">
                                        <h4>{item.title}</h4>
                                        <div className="underline-divider mb-3"></div>
                                        <p>{item.text}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Lifecycle */}
            <section className="container-xxl ptb-50" >
                <h2 className="modern-title text-start text-blue">
                    Study Abroad Programs
                </h2>
                <div class="underline-divider mb-3"></div>
                <p className="lead">
                    The opportunities that ISBM University has for allowing the students to study abroad help the students to
                    learn other cultures and methodologies. These programs provide valuable international exposure and experiences,
                    enabling students to:These programs provide valuable international exposure and experiences, enabling students to:
                </p>
                <Row className="m-0">
                    <Col md={6}>
                        <Row className="g-4">
                            {marketingData.slice(1).map((item, index) => (
                                <Col key={index} md={12}>
                                    <Card
                                        className={`ups-card p-4 h-100 ${item.dark ? '' : 'border'}`}
                                    >
                                        <Card.Title className="fw-bold">
                                            {item.title}
                                        </Card.Title>
                                        <Card.Text className="text-black">{item.content}</Card.Text>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                    <Col md={6}>
                        <Row className="g-4">
                            {marketingData.slice(0, 1).map((item, index) => (
                                <Col key={index} md={12}>
                                    <Card
                                        className={`ups-card p-4 h-100 ${item.dark ? '' : 'border'}`}
                                    >
                                        <Card.Title className="fw-bold">
                                            {item.title}
                                        </Card.Title>
                                        <Card.Text className="text-black">{item.content}</Card.Text>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            </section >

            <section className="ptb-50 bg-light">
                <div className="container-xxl">
                    <Row className="justify-content-center mb-5">
                        <Col lg={10} className="text-center">
                            <h2 className="text-blue modern-title section-title mb-3">
                                Global Industry Partnerships
                            </h2>
                            <p className="lead">
                                We have established partnerships with various international organizations and companies
                                that enhance our students' learning experiences. These partnerships provide:
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        {principles.map((item, index) => (
                            <Col key={index} md={6} lg={4}>
                                <div className="facility-card p-4 h-100 bg-white rounded-3 shadow-sm text-center">
                                    <div className="facility-icon mb-3 text-primary fs-1">
                                        <i className={`${item.icon} facility-icon-style`}></i>
                                    </div>
                                    <h4 className="fw-semibold mb-2">{item.title}</h4>
                                    <p className="mb-0 text-muted">{item.description}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default GlobalSkills;
